import React, { PureComponent, ReactNode } from "react";
import { Link as LinkRouterDom } from "react-router-dom";
import history from "src/lib/history";
import { isUrlAbsolute, isUrlInternalAbsolute } from "src/lib/utils/urls";

import { isLaptopOrUp } from "../RenderOn/RenderOn.component";

import createHistoryHashObserver from "./createHistoryHashObserver";
import forceMagento from "./force-magento";
import keepReact from "./keep-react";

interface IProps {
  children: string | ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  to?: string | null;
  background?: string;
}

export const needReload = (to?: string | null): to is string =>
  !!to &&
  (forceMagento.some((reg: RegExp) => reg.test(to)) ||
    (isLaptopOrUp() && keepReact.every((reg: RegExp) => !reg.test(to))));

export default class Hyperlink extends PureComponent<IProps> {
  public render(): ReactNode {
    const { to, children, className, background } = this.props;

    if (to) {
      return isUrlInternalAbsolute(to) ? (
        <a
          href={to}
          className={className}
          onClick={this.desktopRedirect}
          style={{ backgroundColor: background }}
        >
          {children}
        </a>
      ) : isUrlAbsolute(to) ? (
        <a
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          className={className}
          onClick={this.desktopRedirect}
          style={{ backgroundColor: background }}
        >
          {children}
        </a>
      ) : (
        <LinkRouterDom
          to={to}
          className={className}
          onClick={this.desktopRedirect}
          style={{ backgroundColor: background }}
        >
          {children}
        </LinkRouterDom>
      );
    } else {
      return children;
    }
  }
  private desktopRedirect = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    const { to, onClick } = this.props;

    createHistoryHashObserver(history);

    if (needReload(to)) {
      e.preventDefault();
      window.location.assign(to);
    } else if (onClick) {
      onClick(e);
    }
  };
}
